// Importing required modules
import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

// Create an Axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config: any) => {
    // Add Authorization token if available
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `${token}`,
      };
    }
    return config;
  },
  (error: AxiosError) => {
    // console.log(error)
    // Handle request errors
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    // Process successful response
    return response.data;
  },
  (error: AxiosError|any) => {
    if(error?.response?.data?.code === 401||error?.response?.data?.code === 403){
        localStorage.clear()
        window.location.replace("/");
    }
    // Handle response errors
    if (error.response) {
      console.error('API Error:', error.response.status, error.response.data);
    } else {
      console.error('Network Error:', error.message);
    }
    return Promise.reject(error);
  }
);

// Example service functions
export const getApi = async (endpoint: string, params = {}): Promise<any> => {
  try {
    const response = await apiClient.get(endpoint, { params });
    return response;
    
  } catch (error:AxiosError | any) {
    return error.response.data;
  }
};

export const postApi = async (endpoint: string, data: any): Promise<any> => {
  try {
    const response = await apiClient.post(endpoint, data);
    return response;
  } catch (error: AxiosError | any) {
    return error.response.data;
  }
};

export const putApi = async (endpoint: string, data: any): Promise<any> => {
  try {
    const response = await apiClient.put(endpoint, data);
    return response;
  } catch (error: AxiosError | any) {
    return error.response.data
  }
};

export const patchApi = async (endpoint: string, data: any): Promise<any> => {
  try {
    const response = await apiClient.patch(endpoint, data);
    return response;
  } catch (error: AxiosError | any) {
    return error.response.data
  }
};

export const deleteApi = async (endpoint: string): Promise<any> => {
  try {
    const response = await apiClient.delete(endpoint);
    return response;
  } catch (error: AxiosError | any) {
    return error.response.data
  }
};


export default apiClient;
